import React from 'react';
import { IonIcon, IonGrid, IonRow, IonCol } from '@ionic/react';
import { logoFacebook, logoTwitter, logoYoutube } from 'ionicons/icons';

const ManateeFooter: React.FC = () => {
  return (
    <footer role="contentinfo">
      <IonGrid className="footer-link-grid">
        <IonRow className="ion-justify-content-center">
          <IonCol size="auto">
            <a
              href="https://www.facebook.com/manatee.county.fl/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Manatee County on Facebook (opens in new tab)"
            >
              <IonIcon icon={logoFacebook} style={{ fontSize: '18px' }} aria-hidden="true" />
            </a>
          </IonCol>

          <IonCol size="auto">
            <a
              href="https://twitter.com/manateegov"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Manatee County on Twitter (opens in new tab)"
            >
              <IonIcon icon={logoTwitter} style={{ fontSize: '18px' }} aria-hidden="true" />
            </a>
          </IonCol>
          <IonCol size="auto">
            <a
              href="https://www.youtube.com/user/ManateeCountyFla"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Manatee County on YouTube (opens in new tab)"
            >
              <IonIcon icon={logoYoutube} style={{ fontSize: '18px' }} aria-hidden="true" />
            </a>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonCol>
            <div style={{ textAlign: 'center' }}>
              <span aria-label="Copyright 2020">&#169; Copyright 2020</span>&nbsp;
              <a
                href="https://mymanatee.org/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Manatee County website (opens in new tab)"
              >
                Manatee County
              </a>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </footer>
  );
};

export default ManateeFooter;
